export default __webpack_public_path__ + "f3294b6e0d23e6fdb3056baa65d53bb7.png";